import React from 'react';
import styled from 'styled-components';
import withStyles from '@mui/styles/withStyles';
import { TableRow, TableCell, Table } from '@mui/material';
import SVGIcon from '../SVGIcon/SVGIcon';
import { mixins, fonts, colors } from '../css';

export const TableWrapper = styled.div`
  overflow-x: auto;
`;

export const StyledSVGIcon = styled(SVGIcon)`
  margin: ${mixins.pxToRem(7)} ${mixins.pxToRem(5)} 0 ${mixins.pxToRem(5)};
`;

export const StyledRow = styled(TableRow)({});

export const StyledCell = withStyles({
  root: {
    letterSpacing: 0,
    border: 'none'
  },
  body: {
    fontFamily: fonts.fontRegular,
    fontSize: 16
  }
})(TableCell);

const spreadWidthProp = ({ minTableWidth, children, ...rest }) => <Table {...rest}>{children}</Table>;

export const StyledTable = styled(spreadWidthProp)`
  min-width: ${({ minTableWidth }) => minTableWidth};
`;

export const StyledEmptyCell = styled.div`
  color: ${colors.colorGrey03};
`;
